module.exports = __webpack_public_path__ + "static/img/l.c96b450.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about/l.jpg
// module id = HOl8
// module chunks = 1